type NetworksType = Record<string, SizeType>;

interface SizeType {
  width: number;
  height: number;
}

export const socialClick = (socialShareElements: NodeListOf<HTMLElement>): void => {
  const networks: NetworksType = {
    facebook: { width: 600, height: 300 },
    twitter: { width: 600, height: 254 },
    other: { width: 670, height: 460 },
  };

  socialShareElements.forEach((element) => {
    element.addEventListener('click', (evt) => {
      const { network, shareUrl } = element.dataset;

      if (!network || !shareUrl || !networks[network]) return;
      evt.preventDefault();

      window.open(
        shareUrl,
        'sharer',
        `toolbar=0,status=0,width=${networks[network].width},height=${networks[network].height}`
      );
    });
  });
};

export default socialClick;
